var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcAppsTvActive = function SvgIcAppsTvActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-apps-tv-active_svg__ic-apps-tv-active",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 8,
    height: 30,
    rx: 3,
    fill: "#ffc39c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 41,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#ffe6d6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 4,
    width: 46,
    height: 32,
    rx: 4,
    fill: "#ffe6d6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 40,
    height: 26,
    rx: 2,
    fill: "#ffc39c"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 15,
    width: 8,
    height: 2,
    rx: 1,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 16,
    width: 2,
    height: 8,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6061 15.0809C25.1137 14.8633 25.7016 15.0984 25.9192 15.6061L28 20.4614L30.0809 15.6061C30.2984 15.0984 30.8863 14.8633 31.3939 15.0809C31.9016 15.2984 32.1367 15.8863 31.9192 16.3939L28.9192 23.3939C28.7616 23.7616 28.4 24 28 24C27.6 24 27.2384 23.7616 27.0809 23.3939L24.0809 16.3939C23.8633 15.8863 24.0985 15.2984 24.6061 15.0809Z",
    fill: "white"
  })));
};
export default SvgIcAppsTvActive;